import {baseApi} from "./base-api";

export const reportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWorkOrderReport: builder.query<ReportResponse, string>({
      query: (workOrderId) => ({
        url: `reports/exportWorkOrder`,
        method: 'GET',
        params: {
          workOrderId
        },
        responseHandler: async (response) => {
          const blob = await response.blob();
          const contentDisposition = response.headers.get('content-disposition');
          const fileNameMatch = contentDisposition?.match(/filename="?([^"]+)"?/i);
          const notice = response.headers.get('x-report-notice') ?? undefined;

          return {
            fileName: fileNameMatch?.[1] ?? 'report.zip',
            reportData: blob,
            contentType: response.headers.get('content-type') ?? undefined,
            notice,
          };
        },
      })
    }),
    getWorkOrderReportsZip: builder.mutation<ReportResponse, { workOrderIds: string[] }>({
      query: ({ workOrderIds }) => ({
        url: `reports/exportWorkOrdersZip`,
        method: "POST",
        body: {
          workOrderIds
        },
        responseHandler: async (response) => {
          const blob = await response.blob();
          const contentDisposition = response.headers.get('content-disposition');
          const fileNameMatch = contentDisposition?.match(/filename="?([^"]+)"?/i);

          return {
            fileName: fileNameMatch?.[1] ?? 'reports.zip',
            reportData: blob,
            contentType: response.headers.get('content-type') ?? undefined,
          };
        },
      }),
    }),
    emailWorkOrders: builder.mutation<void, { workOrderIds: string[]; email: string }>({
      query: ({ workOrderIds, email }) => ({
        url: `reports/emailWorkOrderReports`,
        method: "POST",
        body: {
          workOrderIds,
          email,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export interface ReportResponse {
  fileName: string;
  reportData: string | Blob;
  contentType?: string;
  notice?: string;
}

export const {
  useLazyGetWorkOrderReportQuery,
  useEmailWorkOrdersMutation,
  useGetWorkOrderReportsZipMutation
} = reportApi;
